var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWorking(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "360px",
    height: "360px",
    viewBox: "0 0 360 360",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Illustration / Empty State / Working-New") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Illustration-/-Empty-State-/-Working-New",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "undraw_settings_ii2j",
    transform: "translate(-0.000001, 34.999996)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M168.706234,3.24226455 C150.313888,8.02022644 134.090685,20.7763805 117.965508,37.5109715 C129.00183,47.5701284 130.000133,64.596058 120.215019,75.8760654 C110.429904,87.1560729 93.4336235,88.5721661 81.9167331,79.0669955 C62.9755769,101.69409 42.2936238,125.614533 17.0512687,145.384628 C-47.2198526,195.722573 84.9495111,287.527021 168.706234,287.527021 C252.462956,287.527021 320.361235,223.887712 320.361235,145.384636 C320.361235,66.8815588 249.420068,-17.725569 168.706234,3.24226455 Z",
    id: "Path",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#9F9FB1",
    opacity: 0.6,
    cx: 192.317009,
    cy: 279.297901,
    rx: 146,
    ry: 11.0130391
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.46185,267.023075 C338.46185,277.592512 332.179363,281.282707 324.428256,281.282707 C324.248715,281.282707 324.069184,281.280122 323.890939,281.276244 C323.531863,281.268492 323.175369,281.251708 322.82405,281.227169 C315.828567,280.732485 310.394669,276.8524 310.394669,267.023075 C310.394669,256.852757 323.391077,244.017804 324.370129,243.065869 L324.371422,243.064577 C324.408884,243.027122 324.428256,243.009038 324.428256,243.009038 C324.428256,243.009038 338.46185,256.454934 338.46185,267.023075 Z",
    id: "Path",
    fill: "#00CACF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.916774,279.665582 L329.049721,272.494432 L323.903851,280.453473 L323.890939,281.276244 C323.531863,281.268492 323.175369,281.251708 322.82405,281.227169 L323.376868,270.653854 L323.372998,270.571195 L323.382025,270.556982 L323.434977,269.557258 L318.276214,261.578824 L323.45049,268.808101 L323.463409,269.01993 L323.880605,261.031173 L319.46451,252.7867 L323.93485,259.629769 L324.370129,243.065869 L324.371425,243.009035 L324.371425,243.064573 L324.299097,256.125564 L328.69582,250.947403 L324.28101,257.250581 L324.16477,264.40364 L328.270868,257.53861 L324.147976,265.456317 L324.083396,269.433259 L330.041696,259.877761 L324.060143,270.820479 L323.916774,279.665582 Z",
    id: "Path",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#2F2E41",
    cx: 172.162046,
    cy: 69.6039352,
    r: 17.2463615
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#A0616A",
    points: "211.858376 221.996514 221.07647 259.16534 230.294203 257.678399 221.07647 215.157236"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.347158,256.78643 C224.347158,256.78643 219.097604,258.561244 219.789598,259.755292 C220.481593,260.949341 220.481596,268.38312 218.102787,271.059278 C215.723978,273.735436 209.776958,282.061268 216.616034,282.35862 C223.455109,282.655972 230.294181,278.195691 230.294181,278.195691 L230.294181,270.464577 L231.48359,277.601002 L232.672998,277.601002 L232.672998,269.572525 C232.672998,269.572525 235.646518,264.517554 233.862406,261.544045 C232.078294,258.570535 230.915364,255.979214 228.671997,256.234146 C226.42863,256.489078 224.347158,256.78643 224.347158,256.78643 Z",
    id: "Path",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#A0616A",
    points: "175.581425 253.515471 174.094845 261.544157 184.501986 261.544157 184.501986 253.515471"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.47364,259.75994 C176.47364,259.75994 173.500119,259.462588 172.608074,263.625502 C171.716029,267.788416 163.687545,273.735439 160.714031,274.627492 C157.740518,275.519544 157.740511,278.493054 161.606084,279.087758 C165.471657,279.682462 175.284235,279.979811 177.663044,276.708942 C179.278004,274.575312 181.179083,272.674232 183.312712,271.059271 L181.825959,279.385103 L184.502116,279.385103 C184.502116,279.385103 186.880933,271.356623 189.259749,268.680465 C191.638566,266.004307 184.502116,259.759932 183.312726,259.759932 L176.47364,259.75994 Z",
    id: "Path",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.903436,131.898982 C161.903436,131.898982 159.821979,137.548653 156.253765,138.440705 C152.685551,139.332758 126.221308,145.577133 126.221308,145.577133 C126.221308,145.577133 103.027928,146.171837 110.164352,151.2268 C117.300776,156.281763 128.89747,151.2268 128.89747,151.2268 C128.89747,151.2268 162.795489,147.063871 165.47165,142.603619 C167.233353,139.568176 168.725811,136.384266 169.931916,133.088386 L161.903436,131.898982 Z",
    id: "Path",
    fill: "#A0616A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.202778,106.921492 C173.202778,106.921492 156.253765,134.575143 158.335226,135.169843 C160.416687,135.764544 179.744502,142.008919 180.636554,139.63011 C181.528607,137.2513 181.528607,126.249314 181.528607,126.249314 L173.202778,106.921492 Z",
    id: "Path",
    fill: "#2F94FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.202778,106.921492 C173.202778,106.921492 156.253765,134.575143 158.335226,135.169843 C160.416687,135.764544 179.744502,142.008919 180.636554,139.63011 C181.528607,137.2513 181.528607,126.249314 181.528607,126.249314 L173.202778,106.921492 Z",
    id: "Path",
    fill: "#000000",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.210734,100.379772 L255.56902,120.004943 C255.56902,120.004943 277.275647,125.654614 272.518033,130.11488 C267.760418,134.575146 252.298158,126.249318 252.298158,126.249318 L209.776962,106.921492 L217.210734,100.379772 Z",
    id: "Path",
    fill: "#A0616A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.147808,84.9175155 C168.147808,84.9175155 175.581587,96.2168539 174.986883,98.8930152 C174.986883,98.8930152 175.581587,100.677128 174.689531,101.866536 C173.797475,103.055944 174.094827,110.192364 174.094827,110.192364 L177.068348,114.355293 L180.933913,101.569195 L182.718026,87.8910469 C182.718026,87.8910469 178.703787,82.3900519 179.298488,79.7138942 C179.893188,77.0377366 168.147808,84.9175155 168.147808,84.9175155 Z",
    id: "Path",
    fill: "#A0616A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.638544,149.145343 C191.638544,149.145343 174.986883,193.748003 174.986883,213.373174 C174.986883,232.998345 168.742512,255.299673 173.500127,257.38113 C178.257741,259.462588 202.343182,259.759947 202.937883,257.38113 C203.532583,255.002314 199.964362,158.363228 198.18025,154.49768 C196.396137,150.632132 191.638544,149.145343 191.638544,149.145343 Z",
    id: "Path",
    fill: "#2F94FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.638544,149.145343 C191.638544,149.145343 174.986883,193.748003 174.986883,213.373174 C174.986883,232.998345 168.742512,255.299673 173.500127,257.38113 C178.257741,259.462588 202.343182,259.759947 202.937883,257.38113 C203.532583,255.002314 199.964362,158.363228 198.18025,154.49768 C196.396137,150.632132 191.638544,149.145343 191.638544,149.145343 Z",
    id: "Path",
    fill: "#000000",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#A0616A",
    cx: 172.013373,
    cy: 75.6996306,
    r: 11.00199
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.284235,109.002953 L174.48796,102.292433 C174.48796,102.292433 172.013373,105.732091 172.013373,108.408249 C172.013373,111.084406 170.526617,120.599643 176.771006,126.546663 C183.015396,132.493682 184.204786,133.68309 184.502135,134.872495 C184.799483,136.061899 186.286247,136.061903 186.286247,136.061903 L194.909406,170.851964 C194.909406,170.851964 197.585564,263.328146 201.748478,264.517547 C205.911392,265.706948 218.697491,264.517547 219.589544,263.030794 C220.481596,261.544041 218.102787,221.996348 218.102787,221.996348 C218.102787,221.996348 224.64451,257.083771 227.02332,257.083771 C229.402129,257.083771 230.888882,252.028804 230.294181,251.731434 C229.699481,251.434064 226.131253,228.538053 224.64451,221.401625 C223.157768,214.265198 223.752458,153.902936 223.752458,153.902936 C223.752458,153.902936 228.510073,146.171808 212.155767,131.006904 C212.155767,131.006904 201.748478,100.677095 201.153777,100.677095 C200.559077,100.677095 188.962383,84.3227861 188.962383,84.3227861 C188.962383,84.3227861 182.420659,84.3227861 181.231255,88.188352 C180.04185,92.0539179 175.284235,109.002953 175.284235,109.002953 Z",
    id: "Path",
    fill: "#2F94FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.394169,86.7016206 L188.962394,84.3228042 C188.962394,84.3228042 203.829946,93.243337 214.237235,93.8380411 C224.644525,94.4327452 224.347169,100.379765 220.184255,104.542679 C216.021341,108.705593 199.667021,122.978463 199.07232,119.410238 C198.47762,115.842014 185.394169,86.7016206 185.394169,86.7016206 Z",
    id: "Path",
    fill: "#2F94FB"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#2F2E41",
    cx: 172.162046,
    cy: 64.8463167,
    rx: 11.8940425,
    ry: 7.13642407
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#2F2E41",
    cx: 173.35145,
    cy: 52.3575737,
    r: 7.13642407
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.836217,48.4920114 C163.836438,44.8385015 166.59567,41.7750834 170.229268,41.3941691 C169.982304,41.3685252 169.73418,41.3555837 169.485888,41.3555837 C165.546531,41.3583858 162.354537,44.5526517 162.354537,48.4920096 C162.354537,52.4313675 165.546531,55.6256333 169.485888,55.6284355 C169.73418,55.6284355 169.982304,55.615494 170.229268,55.5898501 C166.595671,55.2089359 163.83644,52.1455199 163.836217,48.4920114 Z",
    id: "Path",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#3F3D56",
    transform: "translate(198.274878, 182.527603) rotate(-9.547250) translate(-198.274878, -182.527603) ",
    points: "118.569459 135.979639 277.980297 135.979639 277.980297 229.075567 118.569459 229.075567"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.951627,153.670319 L142.550652,171.03734 C141.793863,171.163231 141.0274,170.875817 140.53998,170.283365 C140.052561,169.690912 139.918237,168.883428 140.187607,168.165084 C140.456976,167.44674 141.089116,166.92667 141.845904,166.800779 L246.246876,149.433758 C247.415973,149.240791 248.520428,150.031253 248.714866,151.200106 C248.909305,152.36896 248.120235,153.474409 246.951627,153.670319 L246.951627,153.670319 Z",
    id: "Path",
    fill: "#F4F4F4",
    opacity: 0.348377046
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#00CACF",
    cx: 218.153768,
    cy: 156.283923,
    r: 8.89632578
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.827747,176.971404 L146.426772,194.338425 C145.669984,194.464316 144.90352,194.176902 144.416101,193.58445 C143.928681,192.991997 143.794357,192.184513 144.063727,191.466169 C144.333096,190.747825 144.965236,190.227755 145.722025,190.101864 L250.122996,172.734843 C251.292093,172.541876 252.396548,173.332338 252.590987,174.501191 C252.785425,175.670045 251.996355,176.775494 250.827747,176.971404 L250.827747,176.971404 Z",
    id: "Path",
    fill: "#F4F4F4",
    opacity: 0.348377046
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#00CACF",
    cx: 174.822493,
    cy: 187.437929,
    r: 8.89632578
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.703868,200.272492 L150.302893,217.639513 C149.132999,217.834124 148.026849,217.043501 147.832238,215.873607 C147.637628,214.703713 148.428251,213.597563 149.598145,213.402953 L253.999116,196.035932 C254.756382,195.908981 255.523806,196.19602 256.011884,196.788765 C256.499962,197.38151 256.634413,198.189752 256.364516,198.908587 C256.09462,199.627421 255.46145,200.147449 254.703868,200.272492 Z",
    id: "Path",
    fill: "#F4F4F4",
    opacity: 0.348377046
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#00CACF",
    cx: 211.078046,
    cy: 205.352721,
    r: 8.89632578
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FF6584",
    cx: 99.43143,
    cy: 57.8459957,
    r: 19.6122945
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorking);
export default __webpack_public_path__ + "static/media/working.0e9392286b255364fe1bf3ada961337e.svg";
export { ForwardRef as ReactComponent };